import { render, staticRenderFns } from "./PostComment.vue?vue&type=template&id=6aaa4bd0&scoped=true&"
import script from "./PostComment.vue?vue&type=script&lang=ts&"
export * from "./PostComment.vue?vue&type=script&lang=ts&"
import style0 from "./PostComment.vue?vue&type=style&index=0&id=6aaa4bd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaa4bd0",
  null
  
)

export default component.exports